import { NAME } from './constants';
import * as m from './model';

export const model = (state) => state[NAME] || m.initialState;
export const getBannerByName = (state, bannerName) => model(state)[bannerName];
